function SideModal(wrapperElement, containerElement, buttons){
	this.wrapperElement = wrapperElement;
	this.containerElement = containerElement;
	this.buttons = [];

	if (buttons.nodeType && buttons.nodeType == 1) {
		this.buttons.push(buttonElement);
	}
	else {
		this.buttons.push(buttons.activate.length ? [].slice.call(buttons.activate) : buttons.activate, buttons.deactivate);
	}

	this.buttons = this.buttons.filter(button => button);

	this.toggleSideModal = this.toggleSideModal.bind(this);
	this.blockClicks = this.blockClicks.bind(this);
	this.onTouchMove = this.onTouchMove.bind(this);
	this.onTouchStart = this.onTouchStart.bind(this);
	this.onTouchEnd = this.onTouchEnd.bind(this);
	this.onTransitionEnd = this.onTransitionEnd.bind(this);
	this.update = this.update.bind(this);


	this.startX = 0;
    this.currentX = 0;
    this.touchingSideNav = false;

	this.buttons.forEach(button => {
		if (Array.isArray(button)) {
			button.forEach(buttonInner => {
				buttonInner.addEventListener('click', this.toggleSideModal);
			});
		}
		else {
			button.addEventListener('click', this.toggleSideModal);
		}
	});

	this.containerElement.addEventListener('click', this.blockClicks);
	this.wrapperElement.addEventListener('touchstart', this.onTouchStart);
	this.wrapperElement.addEventListener('touchmove', this.onTouchMove);
	this.wrapperElement.addEventListener('touchend', this.onTouchEnd);
	this.wrapperElement.addEventListener('click', function(){
		if(this.wrapperElement.classList.contains('is-visible')){
			this.toggleSideModal();
		}
	}.bind(this));
}

SideModal.prototype.toggleSideModal = function(e) {
	this.buttons.forEach(button => {
		if (Array.isArray(button)) {
			button.forEach(buttonInner => {
				buttonInner.classList.toggle('is-open')
			});
		}
		else {
			button.classList.toggle('is-open')
		}
	});
	this.containerElement.classList.add('is-animatable');
	this.wrapperElement.classList.toggle('is-visible');
	this.containerElement.classList.toggle('is-active');
	document.documentElement.classList.toggle('no-scroll');//could us a change on resize browser window

	this.wrapperElement.addEventListener('transitionend', this.onTransitionEnd);
};

SideModal.prototype.onTransitionEnd = function() {
	this.containerElement.classList.remove('is-animatable');
	this.wrapperElement.removeEventListener('transitionend', this.onTransitionEnd);
};

SideModal.prototype.onTouchStart = function(e) {
	if(!this.wrapperElement.classList.contains('is-visible'))
		return;

	this.startX = e.touches[0].pageX;
	this.currentX = this.startX;

	this.touchingSideNav = true;
	requestAnimationFrame(this.update);
};

SideModal.prototype.onTouchMove = function(e) {
	if(!this.touchingSideNav)
		return;

	this.currentX = e.touches[0].pageX;
	var translateX = Math.max(0, this.currentX - this.startX);

	if(translateX > 20) {
		e.preventDefault();
	}
};

SideModal.prototype.onTouchEnd = function(e) {
	if(!this.touchingSideNav)
		return;

	this.touchingSideNav = false;

	var translateX = Math.max(0, this.currentX - this.startX);
	this.containerElement.style.transform = '';

	if(translateX > 80) {
		this.toggleSideModal();
	}
};

SideModal.prototype.update = function() {
	if(!this.touchingSideNav)
		return;

	requestAnimationFrame(this.update);

	var translateX = Math.max(0, this.currentX - this.startX);
	this.containerElement.style.transform = 'translateX(' + translateX + 'px)';
};


SideModal.prototype.blockClicks = function(e) {
	e.stopPropagation();
};

export default SideModal;